module.exports = __webpack_public_path__ + "img/tools-button-ns.8376dcd2.svg";